import angular from "angular";
import ckeditorConfig from "./CKEditorOptions";
import saveGuard from "../../../SaveGuard/SaveGuard";

/**
 * Inline CKEditor bridge
 */
export default angular.module('cms.ckeditor.inline.directive', [ckeditorConfig, saveGuard])
    .directive('ckeditorInline', function (CKEditorConfig, SaveGuard) {

        const PREFIX = '__ckd_inline_';
        const TOOLBAR_WRAPPER = 'ckeditorToolbarContainer';
        const TOOLBAR_HEIGHT = 76;

        let counter = 0;

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                onFocus: '&',
                onBlur: '&',
                options: '<',
                contentLoaded: '<'
            },
            link: function (scope, element, attrs, ngModel) {

                let editor;
                let options = angular.copy(CKEditorConfig.getOptions());
                let $toolbarContainer = $('#' + TOOLBAR_WRAPPER);

                options.sharedSpaces = {
                    top: TOOLBAR_WRAPPER
                };

                if(scope.options && scope.options.toolbar) {
                    options.toolbar = [];
                }

                angular.merge(options, scope.options || {});

                let attachEditor = () => {

                    element[0].setAttribute('contenteditable', true);

                    if (!attrs.id) {
                        attrs.$set('id', PREFIX + (++counter));
                    }

                    editor = CKEDITOR.inline(element[0], options);
                    removeClickListener();

                    editor.on('instanceReady', function () {
                        this.focus();
                    });

                    editor.on('focus', function (e) {

                        let elementOffset = $(element).offset();
                        $toolbarContainer.addClass('md-whiteframe-2dp');
                        $toolbarContainer.css({
                            'display': 'block',
                            'top': elementOffset.top - TOOLBAR_HEIGHT,
                            'left': elementOffset.left - 1
                        });

                        SaveGuard.lock();
                        scope.$apply(() => scope.onFocus());
                    });

                    editor.on('blur', function (e) {

                        if (e.editor.checkDirty()) {
                            ngModel.$setViewValue(e.editor.getData());
                            e.editor.resetDirty();
                        }

                        scope.$emit('content-changed');

                        scope.$apply(function () {
                            scope.onBlur();
                            editor.destroy();
                            element[0].setAttribute('contenteditable', false);
                            addClickListener();
                            SaveGuard.unlock();
                        });
                    });
                };

                let removeClickListener = () => {
                    element.off('click', attachEditor);
                    ngModel.$render = renderWithEditor;
                };

                let addClickListener = () => {
                    element.on('click', attachEditor);
                    ngModel.$render = render;
                };

                let renderWithEditor = () =>  {
                    editor.setData(ngModel.$viewValue || '');
                };

                let render = () => {
                    element[0].innerHTML = ngModel.$viewValue || '';
                };

                addClickListener();

            }
        }
    }
).name;


// WEBPACK FOOTER //
// ./src/cmsCore/RichTextEditor/Editors/CKEditor/CKEditorInline.js